import cull from './cull.js';
import isEqual from 'deep-equal';

/* Responsibility: Untangle FINN.travel code from any specific functional library */
export default {
    partial: cull.partial,
    every: cull.all,
    some: cull.some,
    map: cull.map,
    mapdef: cull.mapdef,
    reduce: cull.reduce,
    first: cull.first,
    filter: cull.select,
    remove: cull.reject,
    unique: cull.uniq,
    mapcat: cull.mapcat,
    prop: cull.prop,
    identity: cull.identity,
    select: cull.select,
    keys: cull.keys,
    values: cull.values,
    flatten: cull.flatten,
    isList: cull.isList,
    difference: cull.difference,
    concat: cull.concat,
    bind: cull.bind,
    indexOf: cull.indexOf,
    intersection: cull.intersection,
    isFunction: cull.isFunction,
    forEach(list, fn) {
        return cull.doall(fn, list);
    },

    uniqueBy(list, fn) {
        cull._assert(cull.isList(list), 'uniqueBy expects a list');
        cull._assert(cull.isFunction(fn), 'uniqueBy expects a function');
        const result = [];

        cull.select((item) => {
            if (!cull.some((resultItem) => fn(item, resultItem), result)) {
                result.push(item);
            }
        }, list);

        return result;
    },
    isEqual,
};
